import React, { createContext, useContext, useCallback, useMemo } from "react";

const BookingCtx = createContext(null);

const BOOKING_URL = process.env.REACT_APP_SQUARE_BOOKING_URL;

export const useBooking = () => useContext(BookingCtx);

export const BookingProvider = ({ children }) => {
  const openBooking = useCallback(() => {
    if (BOOKING_URL) {
      window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
    }
  }, []);

  const value = useMemo(() => ({ openBooking }), [openBooking]);

  return <BookingCtx.Provider value={value}>{children}</BookingCtx.Provider>;
};
